import { memo, useEffect, useState } from "react";
import FaNext from "../SVG/Fontawesome/FaNext";

const SkipButton = (props: {
  player: any;
  time: number;
}) => {
  const [remainingTime, setRemainingTime] = useState<number>(props.time);

  const onSkip = () => {
    if (remainingTime) return;
    props.player.trigger("promo-skip");
  }

  useEffect(() => {
    if (!props.player || !props.time) return;
    setRemainingTime(props.time);
    const interval = setInterval(() => {
      setRemainingTime((prev) => Math.max(prev - 1, 0));
    }, 1000);
    return () => {
      clearInterval(interval);
    }
  }, [props.player, props.time]);

  if (!props.player || !props.time) return <></>;

  return (
    <div onClick={onSkip} className="absolute right-2 bottom-5 pill bg-black/75 flex items-center gap-2 !text-white cursor-pointer" id="ad-overlay">
      {remainingTime > 0 && <span>Skip In {remainingTime}</span>}
      {
        !remainingTime && <>
          <span>Skip</span>
          <FaNext className="w-3 h-3" />
        </>
      }
    </div>
  );
}

export default memo(SkipButton);